module.exports = __webpack_public_path__ + "img/clock.eb8b67a2.png";